import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MyHttpClient } from './http-client.service';
import * as i0 from "@angular/core";
import * as i1 from "./http-client.service";
var LtrService = /** @class */ (function () {
    function LtrService(http) {
        this.http = http;
        this.server = "" + environment.server;
    }
    LtrService.prototype.getLtrForRole = function (profileId, role) {
        if (!profileId || !role) {
            return of(null);
        }
        var normalizedRole = role.toLowerCase();
        if (normalizedRole === 'host') {
            return this.getHostLtr(profileId);
        }
        if (normalizedRole === 'guest') {
            return this.getGuestLtr(profileId);
        }
        return of(null);
    };
    LtrService.prototype.getHostLtr = function (profileId) {
        return this.http.get(this.server + "/api/svo/captain/hopr/metrics/" + profileId).pipe(map(function (response) {
            var metrics = response && response.data ? response.data : response;
            var netRides = metrics
                && metrics.lifeTimeRideBehaviour
                && metrics.lifeTimeRideBehaviour.netRides;
            return typeof netRides === 'number' ? netRides : null;
        }), catchError(function () { return of(null); }));
    };
    LtrService.prototype.getGuestLtr = function (profileId) {
        return this.http.get(this.server + "/api/customer-service/profiles/" + profileId + "/lifetime-rides").pipe(map(function (response) {
            var totalDroppedRides = response && response.totalDroppedRides;
            return typeof totalDroppedRides === 'number' ? totalDroppedRides : null;
        }), catchError(function () { return of(null); }));
    };
    LtrService.ngInjectableDef = i0.defineInjectable({ factory: function LtrService_Factory() { return new LtrService(i0.inject(i1.MyHttpClient)); }, token: LtrService, providedIn: "root" });
    return LtrService;
}());
export { LtrService };
